<template>
  <div class="pageArea">
    <Head2></Head2>
    <div class="mainArea">
      <div class="mainInner">
        <div v-if="currentLanguage === 'zh-CN'" class="mainTitle">首页<span>></span>公司简介</div>
        <div v-if="currentLanguage === 'en-US'" class="mainTitle">Home<span>></span>Company Profile</div>
        <img src="../assets/260426/banner_chn.png" v-if="currentLanguage === 'zh-CN'" class="bannerImg" />
        <img src="../assets/260426/banner_gbr.png" v-if="currentLanguage === 'en-US'" class="bannerImg" />
        <!--公司信息-->
        <div class="part">
          <div class="infoArea" v-if="currentLanguage === 'zh-CN'" ref="cp_richTextRef"
            v-html="companyInfo.us_info ? companyInfo.us_info.content : ''"></div>
          <div class="infoArea introduction" v-if="currentLanguage === 'en-US'" ref="cp_richTextRef"
            v-html="companyInfo.us_info ? companyInfo.us_info.content_en : ''"></div>
          <!--公司信息图片-->
          <div class="campanyImgs">
            <img
              v-for="(imgUrl, index) in (companyInfo.us_info && companyInfo.us_info.images ? companyInfo.us_info.images : [])"
              :key="index" :src="imgUrl.image_url" />
            <!-- <img src="../assets/260426/img01.png" /> -->
          </div>
          <div class="line"></div>
        </div>
        <div class="part">
          <div class="partTitle" v-if="currentLanguage === 'zh-CN'">
            <div class="partTitleInner">
              <div class="fontType">PRODUCTION</div>
              <div class="fontType">WORKSHOP</div>
              <div class="cnText">生产车间</div>
            </div>
          </div>
          <div class="partTitle" v-if="currentLanguage === 'en-US'">
            <div class="partTitleInner enLineHeight">
              <div class="fontType">PRODUCTION</div>
              <div class="fontType">WORKSHOP</div>
            </div>
          </div>
          <div class="proArea">
            <!--生产车间信息-->
            <div class="infoArea" v-if="currentLanguage === 'zh-CN'" ref="ws_richTextRef"
              v-html="companyInfo.work_shop ? companyInfo.work_shop.content : ''"></div>
            <div class="infoArea introduction" v-if="currentLanguage === 'en-US'" ref="ws_richTextRef"
              v-html="companyInfo.work_shop ? companyInfo.work_shop.content_en : ''"></div>
            <!--生产车间图片-->
            <div class="infoArea imgsArea">
              <div class="imgs" v-for="(imgGroup, groupIndex) in getWorkshopImageGroups()" :key="groupIndex">
                <img v-for="(imgUrl, index) in imgGroup" :key="index" :src="imgUrl.image_url" />
              </div>
            </div>
            <div class="partTitle2" v-if="currentLanguage === 'zh-CN'">
              <div class="partTitleInner colorBlue">
                <div class="fontType">RAW MATERIAL</div>
                <div class="fontType">PROCESSING</div>
                <div class="cnText">原材料处理</div>
              </div>
            </div>
            <div class="partTitle2" v-if="currentLanguage === 'en-US'">
              <div class="partTitleInner enLineHeight colorBlue">
                <div class="fontType">AW MATERIAL</div>
                <div class="fontType">PROCESSING</div>
              </div>
            </div>
            <!--原材料处理信息-->
            <div class="infoArea noIndent" v-if="currentLanguage === 'zh-CN'" ref="rmp_richTextRef"
              v-html="companyInfo.raw_material_processing ? companyInfo.raw_material_processing.content : ''"></div>
            <div class="infoArea noIndent" v-if="currentLanguage === 'en-US'" ref="rmp_richTextRef"
              v-html="companyInfo.raw_material_processing ? companyInfo.raw_material_processing.content_en : ''"></div>
            <!-- <div class="infoArea noIndent" v-if="currentLanguage === 'zh-CN'">
              <p>
                原材料采用优质的不锈钢材料进行锻造加工投入不同产品的生产中。
              </p>
               
            </div>

            <div class="infoArea noIndent" v-if="currentLanguage === 'en-US'">
              <p>
                The raw materials are forged and processed using high-quality
                stainless steel materials, which are used in the production of
                different products.
              </p>
            </div> -->
            <!--原材料处理图片-->
            <div class="infoArea imgsArea">
              <div class="imgs" v-for="(imgGroup, groupIndex) in getRmpImageGroups()" :key="groupIndex">
                <img v-for="(imgUrl, index) in imgGroup" :key="index" :src="imgUrl.image_url" />
              </div>
            </div>
            <!-- <div class="infoArea imgsArea">
              <div class="imgs">
                <img src="../assets/260426/img8.png" />
                <img src="../assets/260426/img9.png" />
              </div>
            </div> -->

            <div class="partTitle2" v-if="currentLanguage === 'zh-CN'">
              <div class="partTitleInner colorBlue">
                <div class="fontType">CNC MACHINING</div>
                <div class="cnText">数控加工</div>
              </div>
            </div>
            <div class="partTitle2" v-if="currentLanguage === 'en-US'">
              <div class="partTitleInner enLineHeight colorBlue">
                <div class="fontType">CNC</div>
                <div class="fontType">MACHINING</div>
              </div>
            </div>
            <!-- <div class="infoArea noIndent" v-if="currentLanguage === 'zh-CN'">
              <p>
                在数控机床上进行零件加工的一种工艺方法，数控机床加工与传统机床加工的工艺规程从总体上说是一致的，但也发生了明显的变化。用数字信息控制<br />
                零件和刀具位移的机械加工方法。它是解决零件品种多变、批量小、形状复杂、精度高等问题和实现高效化和自动化加工的有效途径。
              </p>
            </div>

            <div class="infoArea noIndent" v-if="currentLanguage === 'en-US'">
              <p class="setTextLine">
                A process method for machining parts on CNC machine tools. The
                process specifications for CNC machine tool machining and
                traditional machine tool <br />
                machining are generally consistent, but there have also been
                significant changes. Control with digital information Mechanical
                machining methods for <br />
                producing parts and tool displacement. It is an effective way to
                solve the problems of variable parts varieties, small batch
                sizes, complex shapes, high <br />
                precision, and achieve efficient and automated
              </p>
            </div> -->
            <!--数控加工信息-->
            <div class="infoArea noIndent" v-if="currentLanguage === 'zh-CN'" ref="cnc_richTextRef"
              v-html="companyInfo.cnc_machining ? companyInfo.cnc_machining.content : ''"></div>
            <div class="infoArea noIndent" v-if="currentLanguage === 'en-US'" ref="cnc_richTextRef"
              v-html="companyInfo.cnc_machining ? companyInfo.cnc_machining.content_en : ''"></div>

            <!--数控加工图片-->
            <div class="infoArea imgsArea">
              <div class="imgs" v-for="(imgGroup, groupIndex) in getCNCImageGroups()" :key="groupIndex">
                <img v-for="(imgUrl, index) in imgGroup" :key="index" :src="imgUrl.image_url" />
              </div>
            </div>
            <!-- <div class="infoArea imgsArea">
              <div class="imgs">
                <img src="../assets/260426/img10.png" />
                <img src="../assets/260426/img11.png" />
              </div>
            </div> -->
            <div class="partTitle2 titleFlex" v-if="currentLanguage === 'zh-CN'">
              <div class="partTitleInner colorBlue">
                <div class="fontType">ADEQUATE</div>
                <div class="fontType">INVENTORY</div>
                <div class="cnText">充足的库存</div>
              </div>
              <!-- <div class="titleDetial">
                <p>我们建立了ERP系统来进行数字化仓储管理，</p>
                <p>共建了1000平的现代化仓库。</p>
              </div> -->
              <div class="titleDetial" ref="int_richTextRef"
                v-html="companyInfo.sufficient_inventory ? companyInfo.sufficient_inventory.content : ''"></div>
            </div>
            <div class="partTitle2 titleFlex" v-if="currentLanguage === 'en-US'">
              <div class="partTitleInner enLineHeight colorBlue">
                <div class="fontType">ADEQUATE</div>
                <div class="fontType">INVENTORY</div>
              </div>
              <!-- <div class="titleDetial">
                <p>
                  We have established an ERP system for digital warehouse
                  management
                </p>
                <p>
                  and jointly built a modern warehouse of 1000 square meters
                </p>
              </div> -->
              <div class="titleDetial" ref="int_richTextRef"
                v-html="companyInfo.sufficient_inventory ? companyInfo.sufficient_inventory.content_en : ''"></div>
            </div>

            <!--库存图片-->
            <div class="infoArea imgsArea">
              <div class="imgs" v-for="(imgGroup, groupIndex) in getInventoryImageGroups()" :key="groupIndex">
                <img v-for="(imgUrl, index) in imgGroup" :key="index" :src="imgUrl.image_url" />
              </div>
            </div>
            <!-- <div class="infoArea imgsArea">
              <div class="imgs">
                <img src="../assets/260426/img12.png" />
                <img src="../assets/260426/img13.png" />
              </div>
            </div> -->

            <div class="partTitle2" v-if="currentLanguage === 'zh-CN'">
              <div class="partTitleInner colorBlue">
                <div class="fontType">QUALITY </div>
                <div class="fontType">INSPECITION</div>
                <div class="cnText">严格的质量检验</div>
              </div>
            </div>
            <div class="partTitle2" v-if="currentLanguage === 'en-US'">
              <div class="partTitleInner enLineHeight colorBlue">
                <div class="fontType">QUALITY</div>
                <div class="fontType">INSPECITION</div>
              </div>
            </div>
            <!-- <div class="infoArea noIndent" v-if="currentLanguage === 'zh-CN'">
              <p>
                从产品装配完需要一系列的产品性能测试，包括材质检验、硬度测试、螺纹测试、<br />
                高压气体测试、震动压力测试等，从而保证产品的各个工序处于的<br />
                稳定状态，质量特性的波动是客观存在的，为了保证出货品100%的<br />
                合格率，需要检验人员的全面把控。
              </p>
            </div>

            <div class="infoArea noIndent" v-if="currentLanguage === 'en-US'">
              <p class="setTextLine">
                A series of product performance tests are required after product assembly, including material
                inspection, hardness testing, <br />
                thread testing, high-pressure gas testing, vibration pressure testing, etc., to ensure that each
                process
                of the product is <br />
                in a stable state. The fluctuation of quality characteristics is objectively present. In order to
                ensure
                a 100% <br />
                pass rate of the products, comprehensive control by inspectors is required.<br />
                precision, and achieve efficient and automated
              </p>
            </div> -->
            <!--质量检验内容-->
            <div class="infoArea noIndent" v-if="currentLanguage === 'zh-CN'" ref="qua_richTextRef"
              v-html="companyInfo.strict_quality_inspection ? companyInfo.strict_quality_inspection.content : ''"></div>
            <div class="infoArea noIndent" v-if="currentLanguage === 'en-US'" ref="qua_richTextRef"
              v-html="companyInfo.strict_quality_inspection ? companyInfo.strict_quality_inspection.content_en : ''">
            </div>

            <!--质量检验图片-->
            <!-- <div class="imgBoxs"> -->
            <div class="imgRow" v-for="(imgGroup, groupIndex) in getQualityImageGroups()" :key="groupIndex">
              <div class="imgBox" v-for="(imgItem, index) in imgGroup" :key="index">
                <img :src="imgItem.image_url" />
                <div class="imgBoxBottom" v-if="currentLanguage === 'zh-CN'">
                  {{ imgItem.image_title }}
                </div>
                <div class="imgBoxBottom" v-if="currentLanguage === 'en-US'">
                  {{ imgItem.image_title_en }}
                </div>
              </div>
            </div>
            <!-- </div> -->

          </div>
          <div class="line"></div>

        </div>



        <div class="part">
          <div class="partTitle partTitle_bg2" v-if="currentLanguage === 'zh-CN'">
            <div class="partTitleInner">
              <div class="fontType">QUALIFICATIONS </div>
              <div class="fontType">AND HONORS </div>
              <div class="cnText">资质荣誉</div>
            </div>
          </div>
          <div class="partTitle partTitle_bg2" v-if="currentLanguage === 'en-US'">
            <div class="partTitleInner enLineHeight">
              <div class="fontType">QUALIFICATIONS </div>
              <div class="fontType">AND HONORS </div>
            </div>
          </div>
          <!--资质荣誉图-->
          <div class="honerList">
            <div class="honerRow" v-for="(imgGroup, groupIndex) in getHonorsImageGroups()" :key="groupIndex">
              <div class="honerBox" v-for="(imgItem, index) in imgGroup" :key="index">
                <img :src="imgItem.image_url" />
              </div>
            </div>
          </div>
          <div class="line"></div>
        </div>
        <div class="part">
          <div class="partTitle partTitle_bg3" v-if="currentLanguage === 'zh-CN'">
            <div class="partTitleInner">
              <div class="fontType">CORPORATE</div>
              <div class="fontType">PATENTS</div>
              <div class="cnText">企业专利</div>
            </div>
          </div>
          <div class="partTitle partTitle_bg3" v-if="currentLanguage === 'en-US'">
            <div class="partTitleInner enLineHeight">
              <div class="fontType">CORPORATE</div>
              <div class="fontType">PATENTS</div>
            </div>
          </div>
          <!--企业专利图-->
          <div class="honerList">
            <div class="patentRow" v-for="(imgGroup, groupIndex) in getPatentsImageGroups()" :key="groupIndex">
              <div class="zizhiBox" v-for="(imgItem, index) in imgGroup" :key="index">
                <img :src="imgItem.image_url" />
              </div>
            </div>
          </div>
          <div class="line"></div>
        </div>

        <div class="part">
          <div class="partTitle partTitle_bg4" v-if="currentLanguage === 'zh-CN'">
            <div class="partTitleInner">
              <div class="fontType">COOPERATION</div>
              <div class="fontType">CASE</div>
              <div class="cnText">合作案例</div>
            </div>
          </div>
          <div class="partTitle partTitle_bg4" v-if="currentLanguage === 'en-US'">
            <div class="partTitleInner enLineHeight">
              <div class="fontType">COOPERATION</div>
              <div class="fontType">CASE</div>
            </div>
          </div>
          <!-- <div class="infoArea  noIndent setLeft" v-if="currentLanguage === 'zh-CN'">
            <p>
              从精密制造到高端装备，从能源重工到先进工业，我们与OMEGA、Keppel、三一重工、中国核工业集团、<br />
              三菱、达涅利等行业领军者并肩同行，以高标准、严要求的协同合作，为客户打造兼具品质与<br />
              效率的解决方案，共同推动产业高质量发展。
            </p>
          </div>
          <div class="infoArea noIndent setLeft" v-if="currentLanguage === 'en-US'">
            <p>
              From precision manufacturing to high-end equipment, from energy heavy industry to advanced industry, we
              stand <br />
              side by side with industry leaders such as OMEGA, Keppel, Sany Heavy Industry, China National Nuclear
              <br />
              Corporation, Mitsubishi and Danieli. With high-standard and stringent collaboration, we create <br />
              cost-effective solutions featuring superior quality and high efficiency for customers, <br />
              and jointly promote the high-quality development of the industry.
            </p>

          </div> -->
          <!-- 合作案信息-->
          <div class="infoArea noIndent setLeft" v-if="currentLanguage === 'zh-CN'" ref="case_richTextRef"
            v-html="companyInfo.cooperation_cases ? companyInfo.cooperation_cases.content : ''"></div>
          <div class="infoArea noIndent setLeft" v-if="currentLanguage === 'en-US'" ref="case_richTextRef"
            v-html="companyInfo.cooperation_cases ? companyInfo.cooperation_cases.content_en : ''">
          </div>
          <div class="line2"></div>
          <!--合作案例图-->
          <div class="honerList">
            <div class="caseRow" v-for="(imgGroup, groupIndex) in getCasesImageGroups()" :key="groupIndex">
              <div class="heZuoBox" v-for="(imgItem, index) in imgGroup" :key="index">
                <img :src="imgItem.image_url" />
              </div>
            </div>
          </div>
          <div class="line2"></div>
        </div>


      </div>
    </div>
    <Foot2></Foot2>
  </div>
</template>

<script>
import Head2 from "../components/head2.vue";
import Foot2 from "../components/foot2.vue";
import { ref, onMounted, getCurrentInstance } from 'vue'

export default {
  components: {
    Head2,
    Foot2,
  },
  data() {
    return {
      // isChina: false,
      companyInfo: {},
      currentLanguage: localStorage.getItem("locale-lang") || "zh-CN",
    };
  },
  created() {
    this.getCompanyInfo();

  },
  mounted() {
    // 在这里执行给富文本加data-v属性的逻辑
    this.addScopeIdToRichText()
  },
  methods: {
    // 获取公司信息
    getCompanyInfo() {
      this.$scUtil.axiosGet(
        this,
        "AboutUsApi/GetAboutUsInforAll",
        {},
        (res) => {
          this.companyInfo = res.data;
          console.log(this.companyInfo);
          // 数据加载完成后，再给富文本加属性
          this.$nextTick(() => {
            this.addScopeIdToRichText()
          })
        }
      )
    },
    // 给富文本里的所有元素自动加上当前组件的data-v-xxx属性
    addScopeIdToRichText() {
      var scopeId = this.$options._scopeId;
      if (!scopeId) return;

      // 获取富文本容器（可能有多个）
      var containers = []
      containers.push(this.$refs.cp_richTextRef);
      containers.push(this.$refs.ws_richTextRef);
      containers.push(this.$refs.qua_richTextRef);
      containers.push(this.$refs.rmp_richTextRef);
      containers.push(this.$refs.cnc_richTextRef);
      containers.push(this.$refs.int_richTextRef);
      containers.push(this.$refs.hon_richTextRef);
      containers.push(this.$refs.pat_richTextRef);
      containers.push(this.$refs.case_richTextRef);

      if (!containers) return;
      // 遍历所有富文本容器
      containers.forEach(container => {
        if (!container) return;
        // 给所有元素加上 data-v-xxx
        var elements = container.querySelectorAll("*");
        for (var i = 0; i < elements.length; i++) {
          elements[i].setAttribute(scopeId, "");
        }
      });
    },
    // 通用图片分组方法
    // images: 图片数组（可选）
    // groupSize: 每组数量（默认2个）
    getImageGroups(images, groupSize = 2) {
      // 确保groupSize是正数
      const size = Math.max(1, groupSize);

      // 如果传入了images参数，直接使用
      if (images) {
        const groups = [];
        for (let i = 0; i < images.length; i += size) {
          groups.push(images.slice(i, i + size));
        }
        return groups;
      }

      // 如果没有传入参数，返回空数组
      return [];
    },
    //获取公司信息图片分组（每两个一组）
    getCompanyInfoImageGroups() {
      if (!this.companyInfo || !this.companyInfo.us_info || !this.companyInfo.us_info.images) {
        return [];
      }
      return this.getImageGroups(this.companyInfo.us_info.images, 2);
    },
    // 获取生产车间图片分组（每两个一组）
    getWorkshopImageGroups() {
      if (!this.companyInfo || !this.companyInfo.work_shop || !this.companyInfo.work_shop.images) {
        return [];
      }
      return this.getImageGroups(this.companyInfo.work_shop.images, 2);
    },
    //获取原料图片分组（每两个一组）
    getRmpImageGroups() {
      if (!this.companyInfo || !this.companyInfo.raw_material_processing || !this.companyInfo.raw_material_processing.images) {
        return [];
      }
      return this.getImageGroups(this.companyInfo.raw_material_processing.images, 2);
    },
    //获取数控加工图片分组（每两个一组）
    getCNCImageGroups() {
      if (!this.companyInfo || !this.companyInfo.cnc_machining || !this.companyInfo.cnc_machining.images) {
        return [];
      }
      return this.getImageGroups(this.companyInfo.cnc_machining.images, 2);
    },
    //获取库存图片分组（每两个一组）
    getInventoryImageGroups() {
      if (!this.companyInfo || !this.companyInfo.sufficient_inventory || !this.companyInfo.sufficient_inventory.images) {
        return [];
      }
      return this.getImageGroups(this.companyInfo.sufficient_inventory.images, 2);
    },
    //获取质量检测图片分组（每两个一组）
    getQualityImageGroups() {
      if (!this.companyInfo || !this.companyInfo.strict_quality_inspection || !this.companyInfo.strict_quality_inspection.images) {
        return [];
      }
      return this.getImageGroups(this.companyInfo.strict_quality_inspection.images, 2);
    },
    //获取资质荣誉图片分组（每四个一组）
    getHonorsImageGroups() {
      if (!this.companyInfo || !this.companyInfo.qualifications_honors || !this.companyInfo.qualifications_honors.images) {
        return [];
      }
      return this.getImageGroups(this.companyInfo.qualifications_honors.images, 4);
    },
    //获取企业专利图片分组（每四个一组）
    getPatentsImageGroups() {
      if (!this.companyInfo || !this.companyInfo.corporate_patent || !this.companyInfo.corporate_patent.images) {
        return [];
      }
      return this.getImageGroups(this.companyInfo.corporate_patent.images, 4);
    },
    //获取合作案例图片分组（每五个一组）
    getCasesImageGroups() {
      if (!this.companyInfo || !this.companyInfo.cooperation_cases || !this.companyInfo.cooperation_cases.images) {
        return [];
      }
      return this.getImageGroups(this.companyInfo.cooperation_cases.images, 5);
    }
  },
  watch: {},
};
</script>

<style scoped>
.mainArea {
  background: #ebecee;
  width: 100%;
  display: flex;
  justify-content: center;
}

.mainInner {
  width: 1210px;
  margin-bottom: 31px;
  box-sizing: border-box;
  background: #fff;
}

.mainTitle {
  font-size: 13px;
  color: #333333;
  padding: 14px 42px 14px 31px;
}

.mainTitle span {
  margin: 0 13px 0 9px;
}

.bannerImg {
  width: 1210px;
  height: 436px;
}

.infoArea {
  padding: 42px 2px 42px 0;
  box-sizing: border-box;
}

.infoArea p {
  font-size: 15px;
  line-height: 36px;
  text-indent: 24px;
  margin-bottom: 15px;
}

.infoArea p:nth-last-child(1) {
  margin-bottom: 0px;
}

.campanyImgs {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
}

.part {
  margin: 0 40px 45px 35px;
  box-sizing: border-box;
}

.line {
  width: 1116px;
  height: 1px;
  border-bottom: 1px solid #e2e2e2;
  margin: 0 auto;
}

.partTitle {
  width: 1129px;
  height: 119px;
  background: url(../assets/260426/img3.png);
  padding: 0 21px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.partTitle_bg2 {
  background: url(../assets/260426/img50.png);
}


.partTitle_bg3 {
  background: url(../assets/260426/img51.png);
}


.partTitle_bg4 {
  background: url(../assets/260426/img52.png);
}


.partTitle2 {
  width: 1009px;
  min-height: 77px;
  display: flex;
  align-items: center;
}

.partTitleInner {
  border-left: 2px solid #bf1e24;
  padding-left: 21px;
  box-sizing: border-box;
  color: #fff;
  font-weight: bolder;
  min-height: 71px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.colorBlue {
  color: #3d65a2;
}

.enLineHeight {
  line-height: 30px;
}

.fontType {
  font-size: 21px;
  font-family: Arial, Helvetica, sans-serif;
}

.cnText {
  font-size: 18px;
  font-weight: normal;
}

.proArea {
  padding: 0 60px;
  margin-bottom: 45px;
  box-sizing: border-box;
}

.imgs {
  margin-bottom: 18px;
}

.imgs img:nth-child(1) {
  margin-right: 20px;
}

.imgsArea {
  padding-top: 0px;
}

.imgsArea .imgs:nth-last-child(1) {
  margin-bottom: 0px;
}

.noIndent {
  padding: 30px 2px 30px 0;
}

.noIndent p {
  text-indent: 0;
}

.setTextLine {
  letter-spacing: -0.3px;
}

.titleFlex {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
}

.titleDetial {
  font-size: 15px;
  color: #000;
  margin-left: 45px;
  line-height: 30px;
}

.imgBox {
  width: 492px;
  height: 425px;
  border: 1px solid #e2e2e2;
  margin-right: 19px;
  margin-bottom: 26px;
  padding: 12px 12px 0 12px;
  box-sizing: border-box;
}

.imgBox:nth-child(2n+2) {
  margin-right: 0px;
}

.imgBox:nth-last-child(1),
.imgBox:nth-last-child(2) {
  margin-bottom: 0px;
}

.imgBox img {
  width: 469px;
  height: 356px;
}

.imgBoxBottom {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #000;
  margin-top: -8px;
}

.imgBoxs,
.honerList {
  display: flex;
  flex-wrap: wrap;
}

/* 质量检验图片行样式 */
.imgRow {
  display: flex;
  width: 100%;
  margin-bottom: 26px;
}

.imgRow .imgBox {
  margin-right: 19px;
}

.imgRow .imgBox:nth-child(2n+2) {
  margin-right: 0;
}

.imgRow:nth-last-child(1) {
  margin-bottom: 0;
}

.honerList {
  justify-content: center;
  margin: 46px 0;
}

/* 资质荣誉图片行样式 */
.honerRow {
  display: flex;
  justify-content: center;
  margin-bottom: 22px;
  width: 100%;
}

.honerRow .honerBox {
  margin-right: 22px;
  margin-bottom: 0;
}

.honerRow .honerBox:nth-child(4n+4) {
  margin-right: 0;
}

.honerRow:nth-last-child(1) {
  margin-bottom: 0;
}

/* 企业专利图片行样式 */
.patentRow {
  display: flex;
  justify-content: center;
  margin-bottom: 21px;
  width: 100%;
}

.patentRow .zizhiBox {
  margin-right: 21px;
  margin-bottom: 0;
}

.patentRow .zizhiBox:nth-child(4n+4) {
  margin-right: 0;
}

.patentRow:nth-last-child(1) {
  margin-bottom: 0;
}

/* 合作案例图片行样式 */
.caseRow {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  width: 100%;
}

.caseRow .heZuoBox {
  margin-right: 15px;
  margin-bottom: 0;
}

.caseRow .heZuoBox:nth-child(5n+5) {
  margin-right: 0;
}

.caseRow:nth-last-child(1) {
  margin-bottom: 0;
}

.honerBox {
  width: 236px;
  height: 326px;
  border: 1px solid #e5e5e5;
  padding: 8px;
  box-sizing: border-box;
  margin: 0 22px 22px 0;
}

.honerBox:nth-child(4n+4) {
  margin-right: 0px;
}

.honerBox:nth-last-child(1),
.honerBox:nth-last-child(2),
.honerBox:nth-last-child(3),
.honerBox:nth-last-child(4) {
  margin-bottom: 0px;
}

.zizhiBox {
  width: 263px;
  height: 364px;
  border: 1px solid #e5e5e5;
  padding: 8px;
  box-sizing: border-box;
  margin: 0 21px 21px 0;
}

.zizhiBox:nth-child(4n+4) {
  margin-right: 0px;
}

.zizhiBox:nth-last-child(1),
.zizhiBox:nth-last-child(2),
.zizhiBox:nth-last-child(3),
.zizhiBox:nth-last-child(4) {
  margin-bottom: 0px;
}

.heZuoBox {
  width: 188px;
  height: 189px;
  border: 1px solid #e5e5e5;
  margin: 0 15px 15px 0;
}

.heZuoBox:nth-child(5n+5) {
  margin-right: 0px;
}


.heZuoBox:nth-last-child(1),
.heZuoBox:nth-last-child(2),
.heZuoBox:nth-last-child(3),
.heZuoBox:nth-last-child(4),
.heZuoBox:nth-last-child(5) {
  margin-bottom: 0px;
}

.line2 {
  width: 1009px;
  height: 8px;
  background: #3d65a2;
  margin: 0 auto;
}

.setLeft {
  padding-left: 60px;
  box-sizing: border-box;
}

.introduction {
  padding-left: 14px;
}
</style>